var MDB = window.MDB || {};
MDB.Zeiss = MDB.Zeiss || {};

(function ($) {
    MDB.Zeiss.CompaniesTable = {
        boot: function() {
            var crudServiceBaseUrl = '/api/Zeiss/Companies/';      
            var grid = $('#grid');
        
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + 'get', 'GET', options);
                    },
                    create: function (options) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + 'post', 'POST', options);
                    },
                    update: function (options) {
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl + 'put', 'POST', options);
                        options.success();
                    },
                    //Handled in custom command handler
                    destroy: $.noop
                },
                batch: false,
                pageSize: 20,
                schema: {
                    model: {
                        id: 'Id',
                        fields: {
                            Id: { editable: false, type: 'string' },
                            CompanyName: { nullable: true  },
                            ManagerFirstName: { nullable: true },
                            ManagerLastName: { nullable: true },
                            ManagerEmail: { nullable: true },
                            PhoneNumber: { nullable: true },
                            Url: { nullable: true, editable: false}
                        }
                    }
                },
                error: function (e) {
                    this.cancelChanges();
                    alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                }
            });
        
            var gridConfig = {
                dataSource: dataSource,
                pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
                columns: [
                    {
                        field: 'Id',
                        title: 'Id',
                        hidden: true
                    },
                    {
                        field: 'CompanyName',
                        title: MDB.loadResourceString('CompanyModel_CompanyName_DisplayName')
                    },
                    {
                        field: 'ManagerFirstName',
                        title: MDB.loadResourceString('CompanyModel_ManagerFirstName_DisplayName')
                    },
                    {
                        field: 'ManagerLastName',
                        title: MDB.loadResourceString('CompanyModel_ManagerLastName_DisplayName')
                    },
                    {
                        field: 'ManagerEmail',
                        title: MDB.loadResourceString('CompanyModel_ManagerEmail_DisplayName')
                    },
                    {
                        field: 'PhoneNumber',
                        title: MDB.loadResourceString('CompanyModel_PhoneNumber_DisplayName')
                    },
                    {
                        field: 'Url',
                        title: MDB.loadResourceString('CompanyModel_Url_DisplayName'),
                        filterable: false,
                        width: '350px',
                        template: function(item) {
                            return `<a class="k-button k-button-icontext k-grid" href="${item.Url}">
                                        ${MDB.loadResourceString('CompanyModel_Url_Button_Text')}
                                    </a>
                                    <a class="k-button k-button-icontext k-grid" href="#" onclick="MDB.copyToClipboard('${item.Url}')">
                                        <i class="far fa-copy"></i> ${MDB.loadResourceString('CompanyModel_CopyLink_Button_DisplayName')}
                                    </a>`;
                        }
                    }
                ],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                filterable: { mode: 'row' }
            }
        
            gridConfig.editable = {
                mode: 'inline',
                confirmation: false
            };       
            var editColumnArray = [];

            //Init edit and delete buttons based on user permissions.
            //promise will always resolve.
            MDB.Zeiss.CompaniesTable.getPermissions().done(function([writepermission, deletePermission]) {
                if(writepermission) {
                    editColumnArray.push('edit');
                    gridConfig.toolbar = ['create'];
                }

                if(deletePermission) {
                    editColumnArray.push(
                        MDB.KendoConfigBuilder.gridCustomDeleteCommand(
                            MDB.loadResourceString('Index_Companies_Delete_Prompt_Title'),
                            MDB.loadResourceString('Index_Companies_Delete_Prompt_Body'),
                            crudServiceBaseUrl + 'DELETE')
                    );
                }

                if(editColumnArray.length > 0) {
                    gridConfig.columns.push(MDB.KendoConfigBuilder.gridCommandColumn(editColumnArray));
                }
                
                //update grid config
                grid.kendoGrid(gridConfig);
            });
        },
        getPermissions: function() {

            //Init new deferred.
            var def = $.Deferred();
            
            //Set our promise for return
            var prom = def.promise();
            
            //Our permission variables.
            var deletePermission = false;
            var writePermission = false;

            //Delete right promise
            var deleteSecurityProm = MDB.Security.validatePermission(
                MDB.Security.Permissions.ZeissCompanies,
                MDB.Security.PermissionGrantTypes.Delete
            ).done(function () {
                //Set delete permission to true if promise resolves.
                deletePermission = true;
            });

            //Write right promise
            var writeSecurityProm = MDB.Security.validatePermission(
                MDB.Security.Permissions.ZeissCompanies,
                MDB.Security.PermissionGrantTypes.Write
            ).done(function () {
                //Set write permission to true if promise resolves.
                writePermission = true;
            });

            //When both promises are resolved.
            $.when(deleteSecurityProm, writeSecurityProm)
            .always(function () {
                //Resolve our promise.
                def.resolve([writePermission, deletePermission]);
            });

            //Return promise
            return prom;
        }
    }
})(jQuery);